module.exports = "/_next/static/images/Marketing-Pieces-4-2f407b02404302b21290b007873c5c57.png";